import { useEffect, useRef } from "react";

/**
 * Reveal-on-scroll wrapper. Adds `in` class when the element enters the viewport.
 * Uses IntersectionObserver; safe on SSR-less CRA setup.
 */
export default function Reveal({ as: Tag = "div", delay = 0, className = "", children, ...rest }) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            el.classList.add("in");
            io.unobserve(el);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  const delayClass = delay === 1 ? "reveal-d1" : delay === 2 ? "reveal-d2" : delay === 3 ? "reveal-d3" : "";
  return (
    <Tag ref={ref} className={`reveal ${delayClass} ${className}`.trim()} {...rest}>
      {children}
    </Tag>
  );
}
